module.exports = __webpack_public_path__ + "img/1sb-shop-similar-black.f7ddb2e.svg";